/**
 * Start downloading the renderer and environment code Pixi's
 * Application.init would otherwise lazy-load. Left alone, that download only
 * begins once a scene's art has arrived, and on a slow line it queues behind
 * everything else; calling this at boot lets it arrive alongside the art.
 * Fire-and-forget; safe to call more than once.
 */
export function preloadRendererCode(): void {
  void import('./rendererWarmupModules').catch(() => {
    /* best effort: Pixi fetches the same code itself during init */
  });
}
